interface BaseSocketEvent {
  timestamp: string;
  userId?: string;
  eventId?: string;
}

export interface TransactionUpdateEvent extends BaseSocketEvent {
  type: 'account_creation' | 'deposit' | 'withdrawal' | 'transfer' | 'yield_accrual';
  status: 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';
  transactionId?: string;
  amount?: number;
  currency?: string;
  message?: string;
  details?: Record<string, any>;
}

export interface PaymentEvent extends BaseSocketEvent {
  transactionId: string;
  amount: number;
  currency: string;
  provider?: string;
  message?: string;
  details?: Record<string, any>;
}

export interface DeviceApprovalRequestEvent extends BaseSocketEvent {
  deviceId: string;
  deviceInfo: {
    name?: string;
    platform?: string;
    browser?: string;
    location?: string;
  };
  requestId: string;
}

export interface DeviceResponseEvent extends BaseSocketEvent {
  deviceId: string;
  requestId: string;
  approved: boolean;
  reason?: string;
}

export interface BalanceUpdateEvent extends BaseSocketEvent {
  address: string;
  balance: {
    balance: number;
    availableBalance: number;
    effectiveYield: number;
    lockedBalance?: number;
    pendingBalance?: number;
  };
}

export interface KycStatusUpdateEvent extends BaseSocketEvent {
  status: string;
  provider?: string;
  subType?: string;
  message?: string;
  details?: Record<string, any>;
}

interface FiatAccountAddedEvent extends BaseSocketEvent {
  fiatAccountId: string;
  bankName: string;
  accountNumber: string;
  currency: string;
  message?: string;
  details?: Record<string, any>;
}

export const SOCKET_EVENTS = {
  TRANSACTION_UPDATE: 'transaction-update',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_FAILED: 'payment-failed',
  DEVICE_APPROVAL_REQUEST: 'device-approval-request',
  DEVICE_APPROVED: 'device-approved',
  DEVICE_REJECTED: 'device-rejected',
  BALANCE_UPDATE: 'balance-update',
  KYC_STATUS_UPDATE: 'kyc-status-update',
  FIAT_ACCOUNT_ADDED: 'fiat-account-added',
  
  // Legacy events for backwards compatibility
  DEPOSIT_SUCCESS: 'deposit-success',
  DEPOSIT_FAILED: 'deposit-failed',
  DEPOSIT_PENDING: 'deposit-pending',
} as const;

export type SocketEventName = typeof SOCKET_EVENTS[keyof typeof SOCKET_EVENTS];

export interface SocketEventMap {
  [SOCKET_EVENTS.TRANSACTION_UPDATE]: TransactionUpdateEvent;
  [SOCKET_EVENTS.PAYMENT_SUCCESS]: PaymentEvent;
  [SOCKET_EVENTS.PAYMENT_FAILED]: PaymentEvent;
  [SOCKET_EVENTS.DEVICE_APPROVAL_REQUEST]: DeviceApprovalRequestEvent;
  [SOCKET_EVENTS.DEVICE_APPROVED]: DeviceResponseEvent;
  [SOCKET_EVENTS.DEVICE_REJECTED]: DeviceResponseEvent;
  [SOCKET_EVENTS.BALANCE_UPDATE]: BalanceUpdateEvent;
  [SOCKET_EVENTS.KYC_STATUS_UPDATE]: KycStatusUpdateEvent;
  [SOCKET_EVENTS.FIAT_ACCOUNT_ADDED]: FiatAccountAddedEvent;
  [SOCKET_EVENTS.DEPOSIT_SUCCESS]: PaymentEvent;
  [SOCKET_EVENTS.DEPOSIT_FAILED]: PaymentEvent;
  [SOCKET_EVENTS.DEPOSIT_PENDING]: PaymentEvent;
}
